import React from 'react';
import * as mobxReact from 'mobx-react';
import { IntlShape } from 'react-intl';
import classnames from 'classnames';

import { OEToggle } from '../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../global/text/text';
import { ICsvColumn } from '../../../../../../api/connections.dao';

interface IProps {
    item: ICsvColumn;
    intl: IntlShape;
    toggleVisibility: (header: string, column: ICsvColumn) => void;
}

export const EventConfigurationModalItem = mobxReact.observer((props: IProps): JSX.Element => {
    const { toggleVisibility, item, intl } = props;
    const { included, header } = item;

    return (
        <div className={classnames('configuration-column__content', {
            'configuration-column__content--excluded': !included
        })}>
            <div className='configuration-column__body'>
                <OEToggle isSelected={included} onClick={() => toggleVisibility(header, item)}/>
                <span className={classnames('', {
                    'configuration-column__disabled': !included
                    })}
                >
                    <Text message={!included ?
                            intl.formatMessage({
                                id: `oe.allEventConnectionCsv.column.${header}`
                            }, {
                                suffix: ' is excluded'
                            }) :
                            intl.formatMessage({
                                id: `oe.allEventConnectionCsv.column.${header}`
                            }, {
                                suffix: ''
                            })}
                    />
                </span>
            </div>
        </div>
    );
});
